const config = {
  name: "breckenridge-town",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: false, // Display "Redemptions left" on promo code card
    mandatoryFields: false,
    userPhoneNumber: true,
    showAdaSupport: true,
    userName: false,
    userPostalCode: false
  },
  parkingSession: {
    // The same day, just before 7 am
    cancelDaysBefore: 0,
    cancelTime: "",
    // Start time offset from midnight, i.e. 7 am
    startOffsetHrs: 7,
    // Start date offset from today (0 = today)
    startOffsetDate: 2,
    // End date offset from start time
    endOffsetDate: 140,
    cancelTimeOptions: [
      {
        cancelDaysBefore: 0,
        cancelTime: "07:00",
        startTimeThreshold: 12
      },
      {
        cancelDaysBefore: 0,
        cancelTime: "16:00",
        startTimeThreshold: 24
      }
    ]
  }
}
export default config
